export default "__VITE_ASSET__CvPb0HQy__"